/**
 * 云空间模块配置
 * 统一管理云空间模块的路由、菜单、权限配置
 * @author 系统
 * @date 2024
 */

import type { ModuleConfig } from '@/types/module-config'

/**
 * 云空间模块配置
 */
const moduleConfig: ModuleConfig = {
  id: 'cloudspace',
  name: '云空间',
  description: '云空间模块，包含文件管理功能',
  version: '1.0.0',
  enabled: true,

  // 路由配置
  routes: [
    {
      path: '/cloudspace',
      name: 'CloudSpace',
      component: '@/layouts/index.vue',
      redirect: '/cloudspace/filesmanager',
      meta: {
        title: '云空间',
        icon: 'Cloudy',
        roles: ['admin', 'super_admin', 'operator'],
        alwaysShow: true,
        order: 300
      },
      children: [
        {
          path: 'filesmanager',
          name: 'CloudSpaceFilesManager',
          component: '@/modules/cloudspace/pages/filesmanager.vue',
          meta: {
            title: '文件管理',
            icon: 'Folder',
            roles: ['admin', 'super_admin', 'operator'],
            permissions: ['cloudspace:file:view'],
            keepAlive: true
          }
        }
      ]
    }
  ],

  // 权限配置
  permissions: [
    // 文件管理权限
    {
      code: 'cloudspace:file:view',
      name: '查看文件管理',
      type: 'menu',
      description: '查看文件管理页面',
      apiPath: '/cloudspace/filesmanager'
    },
    {
      code: 'cloudspace:file:preview',
      name: '预览文件',
      type: 'operation',
      description: '预览文件内容',
      apiPath: '/api/system/file/preview-url'
    }
  ],

  // 导航配置
  navigation: {
    name: 'cloudspace',
    title: '云空间',
    icon: 'Cloudy',
    permissions: ['cloudspace:file:view'],
    order: 300,
    items: [
      {
        id: 'cloudspace-filesmanager',
        title: '文件管理',
        path: '/cloudspace/filesmanager',
        icon: 'Folder',
        order: 1,
        permissions: ['cloudspace:file:view'],
        module: 'cloudspace',
        component: '@/modules/cloudspace/pages/filesmanager.vue',
        children: []
      }
    ]
  }
}

export default moduleConfig
